import React from 'react'
import NavBar from '../Component/NavBarFooter/NavBar'
import Banner from '../Component/About/Banner'
import WhoWeAre from './WhoWeAre'
import Industries from './Industries'
import DesignSection from './DesignSection'
import Footer from '../Component/NavBarFooter/Footer'
import BrandSection from '../Component/HomePage/BrandSection'

function AboutPage() {
  return (
    <>
<NavBar/>
<Banner/>
<WhoWeAre/>
<Industries/>
<DesignSection/>
<div className='mt-5'>
<BrandSection/>
</div>
<Footer/>
    </>
  )
}

export default AboutPage